import { useTranslation } from 'react-i18next';
import type { WeekDateRangeResponse } from '../../api/generated';
import { Dropdown, DropdownOptions } from '../UI';
import { formatDateRangeSmart } from '../../utils/dateUtils';
import styles from './Economics.module.css';

interface PeriodSelectorProps {
  weeks: WeekDateRangeResponse[];
  fromWeek: number;
  toWeek: number;
  onChange: (from: number, to: number) => void;
  disabled?: boolean;
}

export const PeriodSelector = ({ weeks, fromWeek, toWeek, onChange, disabled }: PeriodSelectorProps) => {
  const { t, i18n } = useTranslation();

  const fromOption = weeks.find((w) => w.weekNumber === fromWeek) ?? null;
  const toOption = weeks.find((w) => w.weekNumber === toWeek) ?? null;

  const weekDisplay = (week: WeekDateRangeResponse): string =>
    `${t('economics-week-label', { week: week.weekNumber })} · ${formatDateRangeSmart(
      week.startDate,
      week.endDate,
      i18n.language
    )}`;

  return (
    <div className={styles.period}>
      <Dropdown
        label={t('economics-from-week')}
        placeholder={t('economics-select-week')}
        selectedOption={fromOption ? weekDisplay(fromOption) : undefined}
        disable={disabled}
        width={250}
      >
        <DropdownOptions
          options={weeks}
          selectedOption={fromOption}
          getKey={(w) => w.weekNumber}
          displayOption={weekDisplay}
          handleChange={(w) => onChange(w.weekNumber, toWeek)}
        />
      </Dropdown>
      <Dropdown
        label={t('economics-to-week')}
        placeholder={t('economics-select-week')}
        selectedOption={toOption ? weekDisplay(toOption) : undefined}
        disable={disabled}
        width={250}
      >
        <DropdownOptions
          options={weeks}
          selectedOption={toOption}
          getKey={(w) => w.weekNumber}
          displayOption={weekDisplay}
          handleChange={(w) => onChange(fromWeek, w.weekNumber)}
        />
      </Dropdown>
    </div>
  );
};
